class BESSAppProjectAPIService extends BESSAppAPIServiceBase {

    static getFor(projectId) {
        return new BESSAppProjectAPIService(BESSApp.instance.services.api, projectId);
    }

    constructor(parent, projectId = null) {
        super(parent, 'project/');
        if (projectId != null) {
            this.context.project_id = projectId;
        } else {
            this.context.project_id = $('.app-project-id').data('project-id');
        }
        this.context.category_id = nullIfUndefined($('.app-category-id').data('category-id'));
        this.editor = new BESSAppProjectEditorAPIService(this);
        this.report = new BESSAppProjectReportAPIService(this);
        this.docs = new BESSAppProjectDocsAPI(this);

    }

    credit(code) {
        return new BESSAppProjectCreditAPIService(this, code);
    }

    apiMonitorEvaluating(onSaved, onError = null) {
        this._post('evaluating', {
            data: {},
            onResult: onSaved,
            onError: onError,
        });
    }

    apiMonitorEvaluation(onSaved, onError = null) {
        this._post('evaluation', {
            data: {},
            onResult: onSaved,
            onError: onError,
        });
    }

    apiUpdateAccessibleToCouncil(isAccessibleToCouncil) {
        this._post('accessible-to-council', {
            data: {
                isAccessibleToCouncil: isAccessibleToCouncil
            }
        })
    }


    apiUpdateCategoryAnnotation(annotated, annotation, onSaved = null, onError = null) {
        this._post('annotate-category', {
            data: {
                'annotated': annotated,
                'annotation': annotation,
            },
            onResult: onSaved,
            onError: onError,
        });
    }

    apiToggleBookmark(bookmarkType, bookmarkQualifier, onSaved = null, onError = null) {
        this._post('bookmark', {
                data: {
                    'bookmark_type': bookmarkType,
                    'bookmark_qualifier': bookmarkQualifier,
                },
                onResult: onSaved,
                onError: onError,
            }
        )
    }

    apiCreateVersion(versionName, onSaved, onError = null) {
        this._post('create-version', {
                data: {
                    'version_name': versionName,
                },
                onResult: onSaved,
                onError: onError,
            }
        )
    }

    apiCreateVersionStatus(onSaved, onError = null) {
        this._post('create-version-status', {
                data: {},
                onResult: onSaved,
                onError: onError,
            }
        );
    }

    apiUpgrade(onSaved, onError = null) {
        this._post('upgrade', {
                data: {},
                onResult: onSaved,
                onError: onError,
            }
        );
    }

    apiUpgradeProgress(onSaved, onError = null) {
        this._post('upgrade-progress', {
            data: {},
            onResult: onSaved,
            onError: onError,
        });
    }

}